class Common {
    arrSlice (array:any, subGroupLength:any , firstNum:any) {//数组分割为多个小数组   原数组   切割值  第一数组切割值
        let index = 0;
        let newArray = [];
        if(firstNum){
            newArray.push(array.slice(0, index += firstNum));
        }
        while(index < array.length) {
            newArray.push(array.slice(index, index += subGroupLength));
        }
        return newArray;
    }
    getCookie(objName:any) { //读取cookies
        var arrStr = document.cookie.split("; ");
        for ( var i = 0; i < arrStr.length; i++ ) {
            var temp = arrStr[ i ].split("=");
            if ( temp[ 0 ] == objName ) return unescape(temp[ 1 ]);
        }
    }
}
export default new Common();
